import { NgModule, PLATFORM_ID, NgZone, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule, EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { addIcons } from 'ionicons';
import {
  thumbsUpOutline,
  thumbsDownOutline,
  thumbsUp,
  thumbsDown,
  copyOutline,
  bookmarkOutline,
  arrowBackOutline,
  timeOutline,
  settingsOutline,
  personOutline,
  documentOutline,
  closeOutline,
  addOutline,
  searchOutline,
  globeOutline,
  lockClosedOutline,
  chevronForwardOutline,
  chatbubblesOutline,
  mailOutline,
  callOutline,
  chatbubbleOutline,
  alarmOutline,
  businessOutline,
  cloudUploadOutline,
  documentTextOutline,
  appsOutline,
  attachOutline,
  micOutline,
  sendOutline,
  sparkles,
  checkmarkCircleOutline,
  checkmarkCircle,
  hardwareChipOutline,
  saveOutline,
  alertCircleOutline,
  keyOutline,
  eyeOutline,
  downloadOutline,
  funnelOutline,
  personCircleOutline,
  bugOutline,
  bulbOutline,
  cameraOutline,
  refreshOutline,
  trashOutline,
  chatboxEllipsesOutline
} from 'ionicons/icons';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthGuardModule } from '@angular/fire/auth-guard';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireFunctionsModule, REGION } from '@angular/fire/functions';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import {
  AngularfirestoreCoolStoreService,
  AngularfirestoreCoolStoreFactory,
  AngularfirestorePerfectStoreService,
  AngularfirestorePerfectStoreFactory,
  AngularfirestoreCoolStorageFactory,
  AngularfirestoreCoolStorageService,
  AngularfirestoreVideoStoreService,
  AngularfirestoreVideoStoreFactory,
  AngularfirestoreVideoStorageService,
  AngularfirestoreVideoStorageFactory,
} from './services/angularfirestore-extension.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { HelpIconModule } from './components/help-icon/help-icon.module';
import { ErrorLoggerService } from './logging/directives/error.service';
import { ClickLoggerService } from './logging/directives/ui/click.service';
import { LoggingModule } from './core/logging/logging.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
// import { ApplicantInboxModalComponent } from './components/applicant-inbox-modal/applicant-inbox-modal.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
import {
  CldrIntlService,
  IntlModule,
  IntlService,
} from "@progress/kendo-angular-intl";
import { MigratorService } from './services/job-offer-migrator.service';
import { ImportantMessagesModalComponent } from './components/important-messages-modal/important-messages-modal.component';
import { ContactPanelComponent } from './components/contact-panel/contact-panel.component';
import { PlatformTourOverlayComponent } from './shared/platform-tour/platform-tour-overlay.component';
import { OrganigramChatDockComponent } from './components/organigram-chat-dock/organigram-chat-dock.component';
import { PartnerOnboardingComponent } from './partner-onboarding/partner-onboarding.component';


// Add icons to the global registry
addIcons({
  'thumbs-up-outline': thumbsUpOutline,
  'thumbs-down-outline': thumbsDownOutline,
  'thumbs-up': thumbsUp,
  'thumbs-down': thumbsDown,
  'copy-outline': copyOutline,
  'bookmark-outline': bookmarkOutline,
  'arrow-back-outline': arrowBackOutline,
  'time-outline': timeOutline,
  'settings-outline': settingsOutline,
  'person-outline': personOutline,
  'document-outline': documentOutline,
  'close-outline': closeOutline,
  'add-outline': addOutline,
  'search-outline': searchOutline,
  'globe-outline': globeOutline,
  'lock-closed-outline': lockClosedOutline,
  'chevron-forward-outline': chevronForwardOutline,
  'chatbubbles-outline': chatbubblesOutline,
  'mail-outline': mailOutline,
  'call-outline': callOutline,
  'chatbubble-outline': chatbubbleOutline,
  'alarm-outline': alarmOutline,
  'business-outline': businessOutline,
  'cloud-upload-outline': cloudUploadOutline,
  'document-text-outline': documentTextOutline,
  'apps-outline': appsOutline,
  'attach-outline': attachOutline,
  'mic-outline': micOutline,
  'send-outline': sendOutline,
  'sparkles': sparkles,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'hardware-chip-outline': hardwareChipOutline,
  'save-outline': saveOutline,
  'alert-circle-outline': alertCircleOutline,
  'key-outline': keyOutline,
  'eye-outline': eyeOutline,
  'download-outline': downloadOutline,
  'funnel-outline': funnelOutline,
  'person-circle-outline': personCircleOutline,
  'bug-outline': bugOutline,
  'bulb-outline': bulbOutline,
  'camera-outline': cameraOutline,
  'refresh-outline': refreshOutline,
  'trash-outline': trashOutline,
  'chatbox-ellipses-outline': chatboxEllipsesOutline,
  'checkmark-circle': checkmarkCircle
});

@NgModule({
  declarations: [
    AppComponent,
    UserAvatarComponent,
    ImportantMessagesModalComponent,
    ContactPanelComponent,
    PlatformTourOverlayComponent,
    OrganigramChatDockComponent,
    PartnerOnboardingComponent
  ],
  entryComponents: [],
  imports: [
    LoggingModule,
    HttpClientModule,
    BrowserModule,
    FormsModule,
    IonicModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireAuthGuardModule,
    AngularFireAnalyticsModule,
    AngularFireFunctionsModule,
    AppRoutingModule,
    ButtonsModule,
    LoggingModule,
    BrowserAnimationsModule,
    HelpIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    IntlModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: AngularfirestoreCoolStoreService, deps: [PLATFORM_ID, NgZone], useFactory: AngularfirestoreCoolStoreFactory },
    { provide: AngularfirestorePerfectStoreService, deps: [PLATFORM_ID, NgZone], useFactory: AngularfirestorePerfectStoreFactory },
    { provide: AngularfirestoreCoolStorageService, deps: [PLATFORM_ID, NgZone], useFactory: AngularfirestoreCoolStorageFactory },
    { provide: AngularfirestoreVideoStoreService, deps: [PLATFORM_ID, NgZone], useFactory: AngularfirestoreVideoStoreFactory },
    { provide: AngularfirestoreVideoStorageService, deps: [PLATFORM_ID, NgZone], useFactory: AngularfirestoreVideoStorageFactory },
    { provide: ErrorHandler, useClass: ErrorLoggerService },
    { provide: EVENT_MANAGER_PLUGINS, useClass: ClickLoggerService, multi: true },
    { provide: REGION, useValue: 'europe-west3' },
    {
      provide: IntlService,
      useClass: CldrIntlService,
    },
    {
      //need to be here because i think angular creates the error handler very early before other modules.
      provide: ErrorHandler,
      useClass: ErrorLoggerService
    },
    {
      //need to be here because i think angular creates the event manager very early before other modules.
      provide: EVENT_MANAGER_PLUGINS,
      useClass: ClickLoggerService,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (migratorService: MigratorService) => () => {},
      deps: [MigratorService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
